import React, { useContext } from 'react';

import Heading from '@react/react-spectrum/Heading';

import { RootContext } from '../../root/RootContext';
import { QuickSetupContext } from './Context';
import { PresetCard } from './PresetCard';
import { useAepSandboxSettings } from 'root/hooks';

export default function Presets() {
  const { context } = useContext(QuickSetupContext);

  return (
    <div className="presets">
      <Heading size={3}>Presets</Heading>

      <div className="fields">
        {!context.configuration && <em>Please select configuration</em>}
        {context.configuration && <PresetList />}
      </div>
    </div>
  );
}

function PresetList() {
  const rootContext = useContext(RootContext);
  const { context, setContextValue } = useContext(QuickSetupContext);
  const settings = useAepSandboxSettings(context?.environment?.id);

  const { presets } = context.configuration?.content || {};
  const { currentUser } = rootContext.state;

  if (!presets || presets.length === 0) {
    return <em>Selected configuration doesn't contain any presets</em>;
  }

  const selectPreset = (preset) => {
    setContextValue({ path: 'preset', value: preset });
  };

  const categories = presets
    // only show presets that are visible to everyone (ie. the visibleTo array is not defined) or current user is in visibleTo
    .filter(
      (preset) =>
        !Array.isArray(preset.visibleTo) ||
        (Array.isArray(preset.visibleTo) &&
          preset.visibleTo.includes(currentUser.id))
    )
    // group presets by category
    .reduce((accumulator, value) => {
      const category = value.category || 'Other';
      accumulator[category] = accumulator[category] || [];
      accumulator[category].push(value);

      return accumulator;
    }, {});

  return (
    <div className="category-list">
      {Object.entries(categories)
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([category, categoryPresets]) => (
          <div key={category} className="preset-category">
            <h4 className="spectrum-Heading spectrum-Heading--subtitle3">
              {category}
            </h4>

            <div className="preset-list">
              {categoryPresets.map((preset) => (
                <PresetCard
                  key={preset.name}
                  preset={preset}
                  selected={context?.preset?.name === preset.name}
                  disabled={
                    settings?.quickSetup?.availablePresets &&
                    !settings?.quickSetup?.availablePresets?.includes(
                      preset.name
                    )
                  }
                  onClick={() => selectPreset(preset)}
                />
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}
